export const errorMappings = {
  'route optimization limit reached': 'routeOptimization.alert.routeOptimizationLimitReached',
}

export const errorCreateRoMappings = {
  'all vehicles box_type are empty': 'routeOptimization.alert.allVehiclesBoxTypeEmpty',
  'all vehicles box_type are not related to any product category':
    'routeOptimization.alert.allVehiclesBoxTypeNotRelatedToAnyProductCategory',
  'deliveries could not be processed': 'routeOptimization.alert.deliveriesCouldNotBeProcessed',
  'delivery order load box type is empty': 'routeOptimization.alert.deliveryOrderLoadBoxTypeEmpty',
  'delivery order load box type not match with any vehicle box type':
    'routeOptimization.alert.deliveryOrderLoadBoxTypeNotMatchWithAnyVehicleBoxType',
  'delivery order destination province is not in java island range':
    'routeOptimization.alert.deliveryOrderDestinationProvinceNotInJavaIslandRange',
  'delivery order load is empty': 'routeOptimization.alert.deliveryOrderLoadEmpty',
  'delivery order load is more than 1': 'routeOptimization.alert.deliveryOrderLoadMoreThanOne',
  'delivery order load product SKU is empty':
    'routeOptimization.alert.deliveryOrderLoadProductSKUEmpty',
  'delivery order udf `Product Type` invalid':
    'routeOptimization.alert.deliveryOrderLoadProductTypeInvalid',
  'delivery order udf `Product Type` required':
    'routeOptimization.alert.deliveryOrderLoadProductTypeRequired',
  'all orders product sku not in warehouse':
    'routeOptimization.alert.allOrdersProductSKUkuNotInWarehouse',
  'all warehouse stock is not enough for all order demand':
    'routeOptimization.alert.allWarehouseStockIsNotEnoughForAllOrderDemand',
}
